/** Shift length helpers — store minutes in the DB, speak hours in the UI. */

export const SHIFT_DURATION_PRESETS = [
  { label: "4h", title: "4 hours", minutes: 240 },
  { label: "6h", title: "6 hours", minutes: 360 },
  { label: "8h", title: "8 hours", minutes: 480 },
  { label: "10h", title: "10 hours", minutes: 600 },
  { label: "12h", title: "12 hours", minutes: 720 },
] as const;

export const SHIFT_MINUTE_STEPS = [0, 15, 30, 45] as const;

export const DEFAULT_SHIFT_DURATION_MINUTES = 480;

export function minutesToParts(totalMinutes: number): { hours: number; minutes: number } {
  const safe = Number.isFinite(totalMinutes) && totalMinutes > 0 ? totalMinutes : 0;
  return { hours: Math.floor(safe / 60), minutes: safe % 60 };
}

export function partsToMinutes(hours: number, minutes: number): number {
  const h = Number.isFinite(hours) && hours >= 0 ? hours : 0;
  const m = Number.isFinite(minutes) && minutes >= 0 ? minutes : 0;
  return h * 60 + m;
}

export function formatShiftLength(minutes: number): string {
  const { hours, minutes: rest } = minutesToParts(minutes);
  if (hours === 0 && rest === 0) return "Choose a length";
  if (hours === 0) return `${rest} minutes`;
  if (rest === 0) return hours === 1 ? "1 hour" : `${hours} hours`;
  return `${hours}h ${rest}m`;
}

/** Local end time label from HH:mm start + duration (may roll to next day). */
export function formatShiftEndTime(localStartTime: string, durationMinutes: number): string | null {
  const match = /^(\d{1,2}):(\d{2})/.exec(localStartTime.trim());
  if (match === null || durationMinutes <= 0) return null;
  const startH = Number(match[1]);
  const startM = Number(match[2]);
  if (!Number.isFinite(startH) || !Number.isFinite(startM)) return null;
  const total = startH * 60 + startM + durationMinutes;
  const nextDay = total >= 24 * 60;
  const endTotal = total % (24 * 60);
  const endH = Math.floor(endTotal / 60);
  const endM = endTotal % 60;
  const period = endH >= 12 ? "PM" : "AM";
  const hour12 = endH % 12 === 0 ? 12 : endH % 12;
  const time = `${hour12}:${String(endM).padStart(2, "0")} ${period}`;
  return nextDay ? `${time} (next day)` : time;
}
